import { render, staticRenderFns } from "./QuestionBoxList.vue?vue&type=template&id=9f2145aa&"
import script from "./QuestionBoxList.vue?vue&type=script&lang=ts&"
export * from "./QuestionBoxList.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionBoxList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports